import React from 'react'

import {
  AnimatedTextFallback,
  AnimatedCircleFallback,
} from '../../atoms/animatedFallbacks'
import { iconSize, StyledRow, StyledWrapper } from './styles'

const TabsMenuFallback = () => {
  return (
    <StyledWrapper>
      <StyledRow>
        <AnimatedCircleFallback size={iconSize} />
        <AnimatedTextFallback />
        <AnimatedTextFallback />
        <AnimatedTextFallback />
      </StyledRow>
    </StyledWrapper>
  )
}

export { TabsMenuFallback }
